import { Sine, TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";

export class Interstitial extends HLF.LoadScreen {
    protected _debugText!: PIXI.BitmapText;
    private _bg!: PIXI.Graphics;

    public init(pSize: PIXI.Point) {
        super.init(pSize);
        this._bg = new PIXI.Graphics();
        this._bg.interactive = true;
        this._bg.alpha = 0;
        this._bg.beginFill(0xffffff);
        this._bg.drawRect(-1, -1, 2, 2);
        this._bg.endFill();
        this._bg.scale.set(this._size.x, this._size.y);

        this.addChild(this._bg);
        this._debugText = this.addChild(HLF.PixiUtils.makeText("Loading...", Constants.FONT_GEL_MED_35, 35));
        this._debugText.alpha = 0;
        this._debugText.position.y = 250;
    }

    public animateIn(pOnComplete: () => void): void {
        this._bg.alpha = 0;
        const timeline: TimelineLite = new TimelineLite();
        timeline.staggerTo([this._bg, this._debugText], 1.0, {
            alpha: 1,
            ease: Sine.easeInOut,
        }, 0.25);
        timeline.call(pOnComplete);
    }

    public animateOut(pOnComplete: () => void): void {
        const timeline: TimelineLite = new TimelineLite();
        timeline.staggerTo([this._debugText, this._bg], 0.5, {
            alpha: 0,
            ease: Sine.easeInOut,
        }, 0.125);
        timeline.call(pOnComplete);
    }

    public onLoadComplete(pCallback: () => void): void {
        pCallback();
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);

        if (this._bg !== undefined) {
            this._bg.scale.set(this._size.x, this._size.y);
        }
    }
}
